import React from 'react';
import i18n from 'i18next';
import { getLocalStorageItem } from '../../utils/cookieAndLocalStorageUtils';
import { redirectToLucLogin } from '../../utils/lucLogin';
import { consumeLoginRedirectBlock } from '../../utils/loginLoopGuard';
import { AuthError } from '../AuthCallback/AuthError';

class Login extends React.Component {
  state = { blocked: false };

  componentDidMount() {
    if (getLocalStorageItem('access_token')) {
      this.props.history.push('/dashboard/units');
      return;
    }

    // We just came back from LUC and the session was rejected again: show the
    // error instead of redirecting into the same loop.
    if (consumeLoginRedirectBlock()) {
      this.setState({ blocked: true });
      return;
    }

    redirectToLucLogin();
  }

  render() {
    if (!this.state.blocked) return null;
    return (
      <AuthError
        message={i18n.t('SESSIONEXPIRED')}
        onTryAgain={redirectToLucLogin}
      />
    );
  }
}

export { Login };
